import {
  AccessibleCompanies,
  Campaign,
  Company,
} from "@vviinn/user-managment-client-ts";

export const getReferenceSiteName = (
  campaign: Campaign,
  accessibleCompanies: AccessibleCompanies[],
  currentCompanyId?: Company["id"],
  defaultReferenceSiteId?: number,
) => {
  const referenceSiteId =
    campaign?.referenceSiteId !== null
      ? campaign?.referenceSiteId
      : campaign?.siteId;

  const referenceCompanyId =
    campaign?.referenceCompanyId !== null
      ? campaign?.referenceCompanyId
      : currentCompanyId;

  if (referenceSiteId === defaultReferenceSiteId) return "Default Catalog";

  const referenceCompany = accessibleCompanies?.find(
    (company) => company.companyId === referenceCompanyId,
  );

  const referenceSite = referenceCompany?.sites?.find(
    (site) => site.id === referenceSiteId,
  );

  return referenceSite?.domain || "Unknown Site";
};
